import { FC, memo } from 'react';

import { IconBaseProps } from 'icons/IconBase';

export const IconLanguageCloseArrows: FC<IconBaseProps> = memo(
  ({ width = 12, height = 24, ...rest }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M2 14L6 18L10 14" stroke="white" strokeWidth="2" />
      <path d="M10 10L6 6L2 10" stroke="white" strokeWidth="2" />
    </svg>
  ),
);
